import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SchedulerLegendComponent } from './scheduler-legend.component';
import { CtExpansionPanelModule } from '@ctsolution/ct-framework';

@NgModule({
  imports: [
    CommonModule,
    CtExpansionPanelModule
  ],
  declarations: [SchedulerLegendComponent],
  exports: [SchedulerLegendComponent]
})
export class SchedulerLegendModule { }
